// import external dependencies
import 'jquery';

// Import everything from autoload
;

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import news from './routes/news';
import contacts from './routes/contacts';
import councilTable from './routes/council-table';
import userProfile from './routes/user-profile';
import singlePost from './routes/single-post';
import singleEvent from './routes/single-event';
import singleAuction from './routes/single-auction';
import singleProject from './routes/single-project';
import vacancies from './routes/vacancies';
import projects from './routes/projects';
import faq from './routes/faq';
import singleSurvey from './routes/single-survey';
import singleFaq from './routes/single-faq';
import search from './routes/search';
import singleService from './routes/single-service';
import singleVacancy from './routes/single-vacancy';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  templateHome: home,
  // Templates
  templateNews: news,
  templateGalleries: news,
  templateEvents: news,
  templateVideos: news,
  templateAuctions: news,
  templateSurveys: news,
  templateProcurements: news,
  templateProjects: projects,
  templateVacancies: vacancies,
  templateFaq: faq,
  templateCouncilTable: councilTable,
  templateContacts: contacts,
  // Tax
  taxonomy: news,
  taxEventCategory: news,
  taxGalleryCategory: news,
  taxVideoCategory: news,
  taxVacancyCategory: vacancies,
  taxFaqCategory: faq,
  category: news,
  // Single post
  singlePost,
  singleEvent,
  singleProject,
  singleFaq,
  singleSurvey,
  singleService,
  singleGallery: singlePost,
  singleVideo: singlePost,
  singleAuction,
  singleVacancy,
  // User
  userProfile,
  // Search
  search,
});

// Load Events
jQuery(document).on('ready', () => routes.loadEvents());
